import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: {
    title: '',
    status: '',
    description: '',
  },
  message: {
    title: '',
    description: '',
  },
  page: {},
  orders: undefined,
};

const orderProgramSlice = createSlice({
  name: 'orderProgram',
  initialState,
  reducers: {
    GET_ORDER_PROGRAM: state => ({ ...state, isLoading: true }),
    GET_ORDER_PROGRAM_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      orders: payload.orders,
    }),
    CREATE_PROGRAM_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      orders: payload,
    }),
    UPDATE_PROGRAM_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      orders: payload,
    }),
    GET_ORDER_PROGRAM_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      orders: undefined,
      message: payload.message,
    }),
    GET_CONTENT: state => ({
      ...state,
      isLoading: true,
    }),
    GET_CONTENT_SUCCESS: (state, { payload }) => ({
      ...state,
      isLoading: false,
      page: payload.page,
    }),
    GET_CONTENT_FAIL: (state, { payload }) => ({
      ...state,
      isLoading: false,
      error: payload.error,
    }),
    RESET_MESSAGES: state => ({
      ...state,
      message: { ...initialState.message },
      error: { ...initialState.error },
    }),
    RESET_STATE: () => ({ ...initialState }),
  },
});

export const {
  GET_ORDER_PROGRAM,
  GET_ORDER_PROGRAM_FAIL,
  GET_ORDER_PROGRAM_SUCCESS,
  CREATE_PROGRAM_SUCCESS,
  UPDATE_PROGRAM_SUCCESS,
  GET_CONTENT,
  GET_CONTENT_SUCCESS,
  GET_CONTENT_FAIL,
  RESET_MESSAGES,
  RESET_STATE,
} = orderProgramSlice.actions;

export const orderProgramSelector = state => state.orderProgram;

export default orderProgramSlice.reducer;
